export default __webpack_public_path__ + "static/media/Plan_at_Move.e616984a.jpg";